!(function ($) {
  var a = {
    url: !1,
    callback: !1,
    target: !1,
    duration: 120,
    touch: !0,
    onZoomIn: !1,
    onZoomOut: !1,
    magnify: 1,
  };
  (($.zoom = function (b, e, a, c) {
    var g,
      h,
      i,
      j,
      k,
      l,
      m,
      f = $(b),
      d = f.css('position'),
      n = $(e);
    return (
      (b.style.position = /(absolute|fixed)/.test(d) ? d : 'relative'),
      (b.style.overflow = 'hidden'),
      (a.style.width = a.style.height = ''),
      $(a)
        .addClass('zoomImg')
        .css({
          position: 'absolute',
          top: 0,
          left: 0,
          opacity: 0,
          width: a.width * c,
          height: a.height * c,
          border: 'none',
          maxWidth: 'none',
          maxHeight: 'none',
        })
        .appendTo(b),
      {
        init: function () {
          ((h = f.outerWidth()),
            (g = f.outerHeight()),
            e === b ? ((j = h), (i = g)) : ((j = n.outerWidth()), (i = n.outerHeight())),
            (k = (a.width - h) / j),
            (l = (a.height - g) / i),
            (m = n.offset()));
        },
        move: function (d) {
          var b = d.pageX - m.left,
            c = d.pageY - m.top;
          ((c = Math.max(Math.min(c, i), 0)),
            (b = Math.max(Math.min(b, j), 0)),
            (a.style.left = -(b * k) + 'px'),
            (a.style.top = -(c * l) + 'px'));
        },
      }
    );
  }),
    ($.fn.zoom = function (b) {
      return this.each(function () {
        var c = $.extend({}, a, b || {}),
          f = (c.target && $(c.target)[0]) || this,
          g = this,
          h = $(g),
          d = document.createElement('img'),
          i = $(d);
        if (!c.url) {
          var e = g.querySelector('img');
          if ((e && (c.url = e.getAttribute('data-src') || e.currentSrc || e.src), !c.url)) return;
        }
        (h.one(
          'zoom.destroy',
          function (a, b) {
            (h.off('.zoom'),
              (f.style.position = a),
              (f.style.overflow = b),
              (d.onload = null),
              i.remove());
          }.bind(this, f.style.position, f.style.overflow)
        ),
          (d.onload = function () {
            var a = $.zoom(f, g, d, c.magnify);
            (a.init(),
              h
                .on('mouseenter.zoom', function (b) {
                  (a.init(),
                    a.move(b),
                    i
                      .stop()
                      .fadeTo(
                        $.support.opacity ? c.duration : 0,
                        1,
                        !!$.isFunction(c.onZoomIn) && c.onZoomIn.call(d)
                      ));
                })
                .on('mouseleave.zoom', function () {
                  i.stop().fadeTo(
                    c.duration,
                    0,
                    !!$.isFunction(c.onZoomOut) && c.onZoomOut.call(d)
                  );
                })
                .on('mousemove.zoom', a.move),
              $.isFunction(c.callback) && c.callback.call(d));
          }),
          d.setAttribute('role', 'presentation'),
          (d.alt = ''),
          (d.src = c.url));
      });
    }),
    ($.fn.zoom.defaults = a));
})(window.jQuery);
